<template>
    <b-modal
        id="m-retur"
        title="Retur Barang Marketplace"
        centered
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        @show="handleModalShow"
    >
        <b-form-group>
            <div>Alasan Retur <span style="color: red;">*</span></div>
            <b-input
                id="retur-reason-input"
                v-model="input.reason"
                maxlength="150"
                placeholder="Masukan alasan retur"
            />
        </b-form-group>

        <b-form-group>
            <div>
                Foto <span style="color: red;">*</span>
                <small class="text-muted">(Maksimal 2 foto)</small>
            </div>
            <b-form-file
                id="retur-photos"
                ref="fileInput"
                v-model="input.photos"
                accept="image/*"
                placeholder="Tambah Foto"
                drop-placeholder="Tambah Foto"
                browse-text="Pilih"
                multiple
                no-drop
                @change="onFileChange"
            />
            <div v-if="photoPreviewUrls.length > 0" class="mt-3">
                <div class="photos-grid">
                    <div
                        v-for="(photo, index) in photoPreviewUrls"
                        :key="index"
                        class="photo-item"
                    >
                        <img
                            :src="photo.url"
                            alt="Preview Foto"
                            class="photo-preview"
                            @click="showPhotoModal(index)"
                        />
                        <b-button
                            variant="danger"
                            size="sm"
                            class="btn-delete-photo"
                            @click="removePhoto(index)"
                        >
                            <i class="fa fa-times"></i>
                        </b-button>
                    </div>
                </div>
            </div>
        </b-form-group>

        <b-form-group label="Biaya Marketplace">
            <b-row>
                <b-col md="10">
                    <b-form-select
                        id="retur-fees-select"
                        v-model="selectedFee"
                        :options="availableFees"
                    >
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled
                                >Pilih Biaya Marketplace</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                </b-col>
                <b-col md="2">
                    <b-button
                        variant="success"
                        @click="addFee"
                        :disabled="selectedFee == null"
                        block
                    >
                        <i class="fa fa-plus" />
                    </b-button>
                </b-col>
            </b-row>
            <div
                v-for="(fee, index) in input.feesList"
                :key="index"
                class="mt-2"
            >
                <b-row>
                    <b-col md="4">
                        <b-form-input
                            :value="fee.name"
                            disabled
                            placeholder="Nama Biaya"
                        />
                    </b-col>
                    <b-col md="6">
                        <b-input-group :prepend="fee.type === 0 ? 'Rp. -' : 'Rp.'">
                            <b-form-input
                                v-model="fee.amount"
                                type="text"
                                @keypress="numberOnly"
                                placeholder="Masukkan nominal"
                                @input="sanitizeFeeAmount(index)"
                                :class="fee.type === 0 ? 'text-danger' : 'text-success'"
                            />
                        </b-input-group>
                    </b-col>
                    <b-col md="2">
                        <b-button
                            variant="danger"
                            @click="removeFee(index)"
                            block
                        >
                            <i class="fa fa-times" />
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-form-group>

        <div class="mt-4 text-right">
            <b-button
                id="btn-exec-return"
                variant="danger"
                :disabled="isSubmitting"
                @click="handleSubmit"
            >
                {{ isSubmitting ? "Memproses..." : "Retur Barang" }}
            </b-button>
        </div>

        <loading-overlay
            :fotoStartTime="uploadTimeStamp.startPresignedUrl"
            :fotoEndTime="uploadTimeStamp.endPresignedUrl"
            :uploadStartTime="uploadTimeStamp.startUploadToS3"
            :uploadEndTime="uploadTimeStamp.endUploadToS3"
            :penyimpananStartTime="uploadTimeStamp.startSaveFile"
            :penyimpananEndTime="uploadTimeStamp.endSaveFile"
            :show="isShowLoadingOverlay"
        />

        <b-modal
            id="m-retur-photo-preview"
            title="Preview Foto Retur"
            size="lg"
            centered
            hide-footer
        >
            <div class="text-center">
                <b-carousel
                    v-if="photoPreviewUrls.length > 0"
                    id="carousel-retur-photos"
                    v-model="currentPhotoIndex"
                    :interval="0"
                    controls
                    indicators
                >
                    <b-carousel-slide
                        v-for="(photo, index) in photoPreviewUrls"
                        :key="index"
                    >
                        <template #img>
                            <img
                                :src="photo.url"
                                class="d-block w-100"
                                alt="Foto Retur"
                                style="max-height: 500px; object-fit: contain;"
                            />
                        </template>
                    </b-carousel-slide>
                </b-carousel>
            </div>
        </b-modal>
    </b-modal>
</template>

<script>
import LoadingOverlay from "../barang-masuk/LoadingOverlay.vue";

export default {
    components: {
        LoadingOverlay
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        itemsToReturn: {
            type: Array,
            required: true
        },
        optFees: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            isSubmitting: false,
            isShowLoadingOverlay: false,

            input: {
                reason: "",
                photos: [],
                feesList: []
            },

            selectedFee: null,

            uploadTimeStamp: {
                startPresignedUrl: null,
                endPresignedUrl: null,
                startUploadToS3: null,
                endUploadToS3: null,
                startSaveFile: null,
                endSaveFile: null
            },

            photoPreviewUrls: [],
            uploadedFilePaths: [],
            currentPhotoIndex: 0,
            salesMarketplaceDirPath: "sales-marketplace"
        };
    },
    methods: {
        handleModalShow() {
            this.input = {
                reason: "",
                photos: [],
                feesList: []
            };
            this.selectedFee = null;
            this.photoPreviewUrls = [];
            this.uploadedFilePaths = [];
            this.currentPhotoIndex = 0;
            this.resetUploadTimestamp();
        },

        handleSubmit() {
            if (this.$helper.isBlank(this.input.reason)) {
                return this.$helper.toastError(
                    this,
                    "Mohon mengisi alasan retur!"
                );
            }

            if (this.uploadedFilePaths.length === 0) {
                return this.$helper.toastError(
                    this,
                    "Mohon upload foto terlebih dahulu!"
                );
            }

            const hasEmptyFee = this.input.feesList.some(
                fee => !fee.amount || fee.amount.trim() === ""
            );
            if (hasEmptyFee) {
                return this.$helper.toastError(
                    this,
                    "Mohon lengkapi nominal semua biaya!"
                );
            }

            let isConfirmed = confirm(
                "Lakukan retur untuk barang-barang marketplace ini?"
            );
            if (!isConfirmed) return;

            this.isSubmitting = true;

            const payload = {
                marketplace_sale_id: parseInt(this.data.id),
                details: this.itemsToReturn.map(it => ({
                    marketplace_sale_detail_id: it.id
                })),
                fees: this.input.feesList.map(fee => ({
                    id: fee.id,
                    amount: this.$helper.toNumber(fee.amount)
                })),
                reason: this.input.reason,
                media: this.uploadedFilePaths
            };

            this.$emit("submit", {
                payload,
                onSuccess: () => {
                    this.isSubmitting = false;
                },
                onError: () => {
                    this.isSubmitting = false;
                }
            });
        },

        showPhotoModal(index) {
            this.currentPhotoIndex = index;
            this.$bvModal.show("m-retur-photo-preview");
        },

        removePhoto(index) {
            this.photoPreviewUrls.splice(index, 1);
            this.uploadedFilePaths.splice(index, 1);
            if (this.photoPreviewUrls.length === 0) {
                this.input.photos = null;
            }
        },

        addFee() {
            if (this.selectedFee == null) {
                return this.$helper.toastError(
                    this,
                    "Mohon pilih jenis biaya terlebih dahulu!"
                );
            }

            const exists = this.input.feesList.find(
                fee => fee.id === this.selectedFee
            );
            if (exists) {
                return this.$helper.toastError(
                    this,
                    "Biaya Marketplace ini sudah ditambahkan!"
                );
            }

            const feeOption = this.optFees.find(
                opt => opt.value === this.selectedFee
            );

            this.input.feesList.push({
                id: this.selectedFee,
                name: feeOption ? feeOption.text : "",
                type: feeOption ? feeOption.type : 1,
                amount: ""
            });

            this.selectedFee = null;
        },

        removeFee(index) {
            this.input.feesList.splice(index, 1);
        },

        numberOnly(event) {
            if (
                (event.charCode >= 48 && event.charCode <= 57) ||
                event.charCode == 13
            ) {
                return true;
            } else {
                event.preventDefault();
            }
        },

        sanitizeFeeAmount(index) {
            let cleaned = String(this.input.feesList[index].amount).replace(
                /\./g,
                ""
            );
            let res = cleaned
                .replace(/(?!^-)[^0-9]/g, "")
                .replace(/^0+(?!$)/, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.input.feesList[index].amount = res;
        },

        formatTime(date) {
            const hours = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");
            const seconds = String(date.getSeconds()).padStart(2, "0");
            const milliseconds = String(date.getMilliseconds()).padStart(
                3,
                "0"
            );
            return `${hours}:${minutes}:${seconds}.${milliseconds}`;
        },

        async getPresignedUrl(fileName, fileType) {
            this.uploadTimeStamp.startPresignedUrl = this.formatTime(
                new Date()
            );
            const payload = {
                file_name: fileName,
                file_type: fileType,
                reference_key: String(this.data.id),
                directory_path: this.salesMarketplaceDirPath
            };
            const response = await this.$axios.post(
                "get-presigned-url",
                payload
            );
            this.uploadTimeStamp.endPresignedUrl = this.formatTime(new Date());
            return response.data.data;
        },

        async uploadToS3(file, presignedUrl) {
            this.uploadTimeStamp.startUploadToS3 = this.formatTime(new Date());
            const response = await fetch(presignedUrl, {
                method: "PUT",
                body: file,
                headers: {
                    "Content-Type": file.type
                }
            });
            if (!response.ok) throw new Error("Upload to S3 failed");
            this.uploadTimeStamp.endUploadToS3 = this.formatTime(new Date());
            return response;
        },

        async onFileChange(event) {
            const files = event.target.files;
            if (!files || files.length === 0) return;

            const currentPhotoCount = this.photoPreviewUrls.length;
            const totalPhotos = currentPhotoCount + files.length;

            if (totalPhotos > 2) {
                this.$helper.toastError(
                    this,
                    "Maksimal 2 foto! Anda tidak bisa menambahkan foto."
                );
                this.input.photos = null;
                this.$refs.fileInput.reset();
                return;
            }

            const allowedImageTypes = ["image/jpeg", "image/png"];
            const maxSize = 400 * 1024 * 1024;

            this.isShowLoadingOverlay = true;
            let successCount = 0;

            try {
                for (let file of files) {
                    if (!allowedImageTypes.includes(file.type)) {
                        this.$helper.toastError(
                            this,
                            `File ${file.name} tidak sesuai dengan tipe file yang diizinkan`
                        );
                        continue;
                    }
                    if (file.size > maxSize) {
                        this.$helper.toastError(
                            this,
                            `File ${file.name} melebihi 400MB`
                        );
                        continue;
                    }

                    const {
                        presigned_url,
                        file_path
                    } = await this.getPresignedUrl(file.name, file.type);

                    await this.uploadToS3(file, presigned_url);

                    const fullPath = `${this.salesMarketplaceDirPath}/${this.data.id}/${file_path}`;
                    const previewUrl = URL.createObjectURL(file);

                    this.photoPreviewUrls.push({
                        url: previewUrl,
                        path: fullPath
                    });
                    this.uploadedFilePaths.push(fullPath);
                    successCount++;
                }

                if (successCount > 0) {
                    this.$helper.toastSuccess(
                        this,
                        `${successCount} foto berhasil diupload`
                    );
                }
            } catch (error) {
                this.$helper.parseError(this, error);
            } finally {
                this.isShowLoadingOverlay = false;
                this.resetUploadTimestamp();
                this.input.photos = null;
                this.$refs.fileInput.reset();
            }
        },

        resetUploadTimestamp() {
            this.uploadTimeStamp = {
                startPresignedUrl: null,
                endPresignedUrl: null,
                startUploadToS3: null,
                endUploadToS3: null,
                startSaveFile: null,
                endSaveFile: null
            };
        }
    },
    computed: {
        availableFees() {
            const selectedFeeIds = this.input.feesList.map(fee => fee.id);
            return this.optFees.filter(
                option => !selectedFeeIds.includes(option.value)
            );
        }
    }
};
</script>

<style scoped>
.photos-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 12px;
}

.photo-item {
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease;
}

.photo-item:hover {
    transform: scale(1.05);
}

.photo-preview {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    cursor: pointer;
}

.btn-delete-photo {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 24px;
    height: 24px;
    padding: 0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}

.btn-delete-photo:hover {
    transform: scale(1.1);
}
</style>
